import { renderSections } from '@/components/sections/renderSections';
import { data } from './data';

export default function Page() {
  return <>{renderSections(data.sections)}</>;
}
